export enum SearchTarget {
    Sites = "sites",
}
